// const API_BASE = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')
const API_BASE  =  'https://admin.myshengtu.cn'
function encodeForm(data) {
  const body = new URLSearchParams()
  Object.keys(data || {}).forEach(key => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') body.append(key, value)
  })
  return body
}

export async function request(path, options = {}) {
  const token = localStorage.getItem('ai_token')
  const headers = { ...(options.headers || {}) }
  if (token) headers.Authorization = `Bearer ${token}`

  let body = options.body
  if (body && !(body instanceof FormData)) {
    body = encodeForm(body)
    headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method: options.method || 'GET',
    headers,
    body,
    cache: options.cache || 'default'
  })
  const result = await response.json().catch(() => null)
  if (!result) throw new Error('服务响应异常，请稍后重试')
  if (result.code !== 1) {
    if (result.code === 401) window.dispatchEvent(new CustomEvent('auth-expired'))
    throw new Error(result.msg || '请求失败')
  }
  return result.data
}

export const api = {
  login: data => request('/api/user/login', { method: 'POST', body: data }),
  register: data => request('/api/user/register', { method: 'POST', body: data }),
  logout: () => request('/api/user/logout', { method: 'POST' }),
  profile: () => request(`/api/user/index?_=${Date.now()}`, { cache: 'no-store' }),
  config: () => request('/api/ai/config'),
  generate: data => request('/api/ai/generate', { method: 'POST', body: data }),
  edit: (data, image) => {
    const body = new FormData()
    Object.keys(data || {}).forEach(key => {
      const value = data[key]
      if (value !== undefined && value !== null && value !== '') body.append(key, value)
    })
    body.append('image', image)
    return request('/api/ai/edit', { method: 'POST', body })
  },
  gallery: params => request(`/api/ai/history?${new URLSearchParams(params).toString()}`),
  // 直接返回下载直链，交给浏览器原生下载，点击后立即开始并显示进度
  downloadUrl: id => {
    const token = localStorage.getItem('ai_token')
    const query = `id=${encodeURIComponent(id)}` + (token ? `&token=${encodeURIComponent(token)}` : '')
    return `${API_BASE}/api/ai/download?${query}`
  },
  removeWork: id => request('/api/ai/delete', { method: 'POST', body: { id } }),
  plans: () => request('/api/recharge/plans'),
  createRecharge: data => request('/api/recharge/create', { method: 'POST', body: data }),
  rechargeStatus: orderNo => request(`/api/recharge/status?order_no=${encodeURIComponent(orderNo)}`)
}

export function assetUrl(url, width) {
  if (!url) return ''
  const source = /^(https?:|data:|blob:)/i.test(url)
    ? url
    : `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`
  if (!width || /^(data:|blob:)/i.test(source)) return source
  return `${source}${source.includes('?') ? '&' : '?'}w=${width}`
}
